export enum EPropertyManagementUrls {
  PROPERTY_MANAGEMENT = 'property-management',
  PROPERTIES = 'properties',
  SEARCH = 'search',
  UNITS = 'units',
  ANALYTICS = 'analytics',
  ALL = 'all',
}
